import React from "react";
import { LoadioArtistListTemplate } from "themes/administration/loadio/pages";
import { LoadioArtistListViewStore } from "administration/loadio/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new LoadioArtistListViewStore(rootStore, componentProps),
    "loadioArtistListViewStore"
)
class LoadioArtistList extends React.Component {
    render() {
        return <LoadioArtistListTemplate {...this.props} />;
    }
}

export default LoadioArtistList;
